var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-overlay', {
    staticClass: "w-100 h-100",
    attrs: {
      "show": _vm.loading,
      "spinner-variant": "primary",
      "spinner-type": "grow"
    }
  }, [_c('b-container', {
    staticClass: "align-content-start",
    attrs: {
      "fluid": ""
    }
  }, [_vm._l(_vm.projectSheets, function (sheet) {
    return _c('div', {
      key: sheet.id,
      staticClass: "d-flex align-items-center my-2"
    }, [_c('span', {
      staticClass: "fill"
    }, [_vm._v(_vm._s(sheet.name))]), _c('b-icon', {
      staticClass: "h3 mx-1",
      attrs: {
        "icon": "file-arrow-down"
      },
      on: {
        "click": function click($event) {
          return _vm.openUpdate(sheet);
        }
      }
    }), _c('router-link', {
      staticClass: "link",
      attrs: {
        "target": "_blank",
        "to": {
          name: 'Sheet',
          params: {
            token: sheet.token
          }
        }
      }
    }, [_c('b-icon', {
      staticClass: "h3 mx-1",
      attrs: {
        "icon": "eye"
      }
    })], 1), _c('b-icon', {
      staticClass: "h3 mx-1",
      attrs: {
        "icon": "pencil"
      },
      on: {
        "click": function click($event) {
          return _vm.openEdit(sheet);
        }
      }
    }), _c('b-icon', {
      staticClass: "h3 mx-1",
      attrs: {
        "icon": "box-arrow-up-right"
      },
      on: {
        "click": function click($event) {
          return _vm.openInvite(sheet);
        }
      }
    }), _c('b-icon', {
      staticClass: "h3 mx-1",
      attrs: {
        "icon": "trash"
      },
      on: {
        "click": function click($event) {
          return _vm.openRemove(sheet);
        }
      }
    })], 1);
  }), _c('b-button', {
    staticClass: "w-100 mt-3",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.openCreate
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('sheet.popup.form.create-sheet')) + " ")]), _c('custom-modal', {
    attrs: {
      "id": "create-sheet-modal",
      "title": _vm.$t("sheet.popup.".concat(_vm.formData.id ? 'update' : 'create', "-title"))
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function fn() {
        return [_c('create-sheet-modal', {
          attrs: {
            "sheet": _vm.formData
          },
          on: {
            "success": _vm.onCreateOrUpdateSuccess
          }
        })];
      },
      proxy: true
    }])
  }), _c('custom-modal', {
    attrs: {
      "id": "invite-modal",
      "title": _vm.$t('sheet.popup.share.title')
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function fn() {
        return [_c('invite-form-sheet', {
          attrs: {
            "id": "invite",
            "error": _vm.error,
            "loading": _vm.loading
          },
          on: {
            "submit": _vm.onInvite
          }
        })];
      },
      proxy: true
    }])
  }), _c('confirmation-modal', {
    attrs: {
      "id": "remove-modal",
      "title-key": "sheet.popup.delete.title"
    },
    on: {
      "on-click-yes": _vm.onRemove
    },
    scopedSlots: _vm._u([{
      key: "body-text",
      fn: function fn() {
        return [_c('p', {
          staticClass: "mb-3 text-center"
        }, [_vm._v(" " + _vm._s(_vm.$t('sheet.popup.delete.message', {
          name: _vm.formData.name
        })) + " ")])];
      },
      proxy: true
    }])
  }), _c('confirmation-modal', {
    attrs: {
      "id": "update-modal",
      "title-key": "sheet.popup.update.title"
    },
    on: {
      "on-click-yes": _vm.onUpdate
    },
    scopedSlots: _vm._u([{
      key: "body-text",
      fn: function fn() {
        return [_c('p', {
          staticClass: "mb-3 text-center"
        }, [_vm._v(" " + _vm._s(_vm.$t('sheet.popup.update.message', {
          name: _vm.formData.name
        })) + " ")])];
      },
      proxy: true
    }])
  })], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }